module.exports = __webpack_public_path__ + "img/26.10.pH.745d080a.png";